// 01.01.2025
export var MAX_CAPPED_INCOME = 5512.5;
export var MIN_CAPPED_INCOME = 2000;
export var MIN_CAPPED_SELF_EMPLOYED_INCOME = 1248.33;
export var PRICE_REDUCTION_MAX_AGE = 23;
export var MAX_STUDENT_AGE = 30;
var providers = {
    TK: 2.45,
    AOK: 2.7,
    DAK: 2.8,
    BARMER: 3.29,
    HKK: 0.69,
};
var studentProviders = {
    TK: 20.95,
    AOK: 23.09,
    DAK: 23.93,
    BARMER: 28.13,
    HKK: 9.02,
};
var getAdditionalAmount = function (provider) { return providers[provider]; };
export var pricingPercentageMap = {
    EMPLOYED: {
        healthInsurance: 7.3,
        additional: function (provider) { return getAdditionalAmount(provider) / 2; },
        longTermCare: { reduced: 1.8, notReduced: 2.4 },
    },
    SELF_EMPLOYED: {
        healthInsurance: 14,
        additional: function (provider) { return getAdditionalAmount(provider); },
        longTermCare: { reduced: 3.6, notReduced: 4.2 },
    },
};
export var studentPricing = {
    healthInsurance: 87.38,
    additional: function (provider) { return studentProviders[provider]; },
    longTermCare: { reduced: 30.78, notReduced: 35.91 },
};
